export const DLG_ECM_FAT = 0.38;
export const DLG_ECM_PROTEIN = 0.21;
export const DLG_ECM_OFFSET = 1.05;
export const DLG_ECM_DIVISOR = 3.28;

export const DAIRY_COW_TYPE_SLUG = {
  holstein_friesian: "holstein_friesian",
  red_holstein: "red_holstein",
  german_simmenthal: "german_simmenthal",
  brown_swiss: "brown_swiss",
  jersey: "jersey",
  mixed_breed_dairy: "mixed_breed_dairy",
  mixed_breed_meat: "mixed_breed_meat",
} as const;

export const DAIRY_COW_BREED_WEIGHTS: Record<keyof typeof DAIRY_COW_TYPE_SLUG, number> = {
  holstein_friesian: 675,
  jersey: 425,
  red_holstein: 675,
  german_simmenthal: 725,
  brown_swiss: 675,
  mixed_breed_dairy: 675,
  mixed_breed_meat: 675,
} as const;
